"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeltaType = void 0;
var DeltaType;
(function (DeltaType) {
    DeltaType[DeltaType["DT_BYTE"] = 1] = "DT_BYTE";
    DeltaType[DeltaType["DT_SHORT"] = 2] = "DT_SHORT";
    DeltaType[DeltaType["DT_FLOAT"] = 4] = "DT_FLOAT";
    DeltaType[DeltaType["DT_INTEGER"] = 8] = "DT_INTEGER";
    DeltaType[DeltaType["DT_ANGLE"] = 16] = "DT_ANGLE";
    DeltaType[DeltaType["DT_TIMEWINDOW_8"] = 32] = "DT_TIMEWINDOW_8";
    DeltaType[DeltaType["DT_TIMEWINDOW_BIG"] = 64] = "DT_TIMEWINDOW_BIG";
    DeltaType[DeltaType["DT_STRING"] = 128] = "DT_STRING";
    DeltaType[DeltaType["DT_SIGNED"] = -2147483648] = "DT_SIGNED";
})(DeltaType || (exports.DeltaType = DeltaType = {}));
